// extracted by mini-css-extract-plugin
export default {"TaskCompany":"TaskCompany_TaskCompany__ymjZh"};